
export class ApiException extends Error {

  constructor(public error: string, public statusCode: number, public correlationId?: string) {
    super(error);
  }

}
